import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

const videoListSlider = {
    slideSection: '.video-list-slider',
    slideSelector: '.swiper-container__video-list',
    swiperNewsListSlider: [],
    nextBtn: '.button--next',
    prevBtn: '.button--prev',

    init: function () {
        let self = this,
            containers = document.querySelectorAll(self.slideSelector);

        const sidebar = document.querySelector('.content-wrapper__column');

        containers.forEach(function (container, index) {
            const $container = container.closest(self.slideSection);
            const slides = $container.querySelectorAll('.swiper-slide');

            self.swiperNewsListSlider[index] = new Swiper(container, {
                enabled: slides && slides.length > 1,
                modules: [Navigation],
                navigation: {
                    nextEl: container.parentElement.querySelector(self.nextBtn),
                    prevEl: container.parentElement.querySelector(self.prevBtn),
                    disabledClass: 'button--disabled',
                },
                slidesPerView: 1,
                spaceBetween: 16.1,
                autoplay: false,
                init: false,
                watchSlidesVisibility: true,
                breakpoints: {
                    768: {
                        enabled: sidebar ? slides && slides.length > 1 : slides && slides.length > 3,
                        slidesPerView: sidebar ? 1 : 3,
                        slidesPerGroup: sidebar ? 1 : 3,
                    },
                    1024: {
                        enabled: sidebar ? slides && slides.length > 2 : slides && slides.length > 3,
                        slidesPerView: sidebar ? 2 : 3,
                        slidesPerGroup: sidebar ? 2 : 3,
                    },
                    1280: {
                        enabled: sidebar ? slides && slides.length > 2 : slides && slides.length > 3,
                        slidesPerView: sidebar ? 2 : 3,
                        slidesPerGroup: sidebar ? 2 : 3,
                    },
                },
            });

            self.swiperNewsListSlider[index].init();
        });
    },
};

document.addEventListener('DOMContentLoaded', function () {
    'use strict';
    if (!document.querySelectorAll('.video-list-slider').length) return;

    videoListSlider.init();
});
